/**
 * Cihaz durumları — değerler sunucudaki `Device.STATUS_NAMES` ile birebir aynı
 * olmalıdır: "Depo" (hastaya bağlı değil), "Servis", "Hastada".
 * `label` hazır filtre çipinde ve durum seçiminde görünen metindir.
 */
export const STATUS_OPTIONS = [
  { value: "Hastada", label: "Hastada" },
  { value: "Servis", label: "Serviste" },
  { value: "Depo", label: "Depoda" },
];

/** StatusPill tonu (recordTableParts) — renk durumu anlatır, metin her zaman yazılı. */
export const STATUS_TONE = { Hastada: "success", Servis: "warning", Depo: "neutral" };

/**
 * Cihaz tipi seçenekleri — değerler sunucudaki `typeCode` alanıyla birebir aynı
 * olmalıdır (`modules/device/domain/device-catalog.js`). Yeni bir cihaz türü
 * eklenirse buraya da eklenmeli; "GEN" katalogda olmayan türlerin fallback'i.
 */
export const TYPE_OPTIONS = [
  { value: "", label: "Tüm tipler" },
  { value: "BPM", label: "Tansiyon Ölçüm Cihazı" },
  { value: "OXY", label: "Oksimetre" },
  { value: "SCL", label: "Akıllı Tartı" },
  { value: "THR", label: "Termometre" },
  { value: "GLU", label: "Şeker Ölçüm Cihazı" },
  { value: "GEN", label: "Diğer" },
];

// NOT: Web'de cihaz OLUŞTURMA yoktur. Cihazlar mobil uygulamadan admin girişiyle
// BLE ile bağlanılarak sisteme tanıtılır (seri no orada otomatik üretilir); bu
// sayfa yalnız listeleme, durum değiştirme ve silme yapar.
